import { connect } from 'react-redux';
import { Cases } from './Cases';
import { getAllColumns, getAllQueries, getAutoPlay, getCasesCollection, getCasesCollectionLoading, getDisplayedColumns, getFilters, getNotificationsActivated, } from 'src/redux/cases/casesSelectors';
import { casesActions } from 'src/redux/cases/casesActions';
import { getI18n } from 'src/redux/core/coreSelectors';
import { withI18nExist } from 'src/shared/helpers/pagesHelpers';
import { coreActions } from 'src/redux/core/coreActions';
var mapStateToProps = function (state) { return ({
    i18n: getI18n(state),
    allQueries: getAllQueries(state),
    filters: getFilters(state),
    allColumns: getAllColumns(state),
    visibleColumns: getDisplayedColumns(state),
    cases: getCasesCollection(state),
    isCasesLoading: getCasesCollectionLoading(state),
    isNotificationsActivated: getNotificationsActivated(state),
    isAutoPlay: getAutoPlay(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    fetchCasesRequested: function () { return dispatch(casesActions.fetchCasesRequested()); },
    updateFilters: function (newFilters) { return dispatch(casesActions.updateSearchFilterRequested(newFilters)); },
    updateColumnRequested: function (newColumns) { return dispatch(casesActions.updateColumnRequested(newColumns)); },
    exportCasesInCSV: function () { return dispatch(casesActions.exportCasesInCSVRequested()); },
    updateIsNotificationsActivated: function (isNotificationsActivated) {
        return dispatch(casesActions.updateIsNotificationsActivated(isNotificationsActivated));
    },
    addNotification: function (notification) { return dispatch(coreActions.addNotificationRequested(notification)); },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(withI18nExist(Cases));
